export const namespaced = true;

import CourseService from '@/services/CourseService.js';
import cloneDeep from 'lodash/cloneDeep';
import map from 'lodash/map';
import omit from 'lodash/omit';
import range from 'lodash/range';
import pick from 'lodash/pick';
import { basicPresent, basicSubFieldPresent } from '@/presenters/fields';

export const state = {
  courses: [],
  course: {},
  editingCourse: null,
};

export const mutations = {
  SET_COURSES(state, courses) {
    state.courses = courses;
  },
  CLEAR_COURSES(state) {
    state.courses = [];
  },
  SET_COURSE(state, course) {
    state.course = course;
  },
  SET_EDITING_COURSE(state, course) {
    state.editingCourse = course;
  },
  DELETE_EDITING_COURSE(state) {
    state.editingCourse = null;
  },
  UPDATE_COURSE(state, course) {
    state.course = course;
  },
  ADD_COURSE(state, course) {
    state.course = course;
  },
  FREEZE_COURSE() {
    // We only freeze Course, so we don't need to do anything here
  },
};

export const actions = {
  fetchCourses({ commit }, { data }) {
    return CourseService.all(data).then((response) => {
      commit('SET_COURSES', response.data);
    });
  },
  clearCourses({ commit }) {
    commit('CLEAR_COURSES');
  },
  fetchCourse({ commit }, id) {
    return CourseService.get(id).then((response) => {
      commit('SET_COURSE', response.data);
      return response.data;
    });
  },
  startEditingCourse({ commit }, course) {
    commit('SET_EDITING_COURSE', course);
  },
  finishEditingCourse({ commit, state }, id) {
    if (state.editingCourse) {
      let formattedCourse = cloneDeep(state.editingCourse);
      if (formattedCourse.corporation) {
        formattedCourse.corporationId = formattedCourse.corporation.id;
        formattedCourse = omit(formattedCourse, ['corporation']);
      }
      if (formattedCourse.brand) {
        formattedCourse.brandId = formattedCourse.brand.id;
        formattedCourse = omit(formattedCourse, ['brand']);
      }
      if (id) {
        return CourseService.update(id, formattedCourse).then((response) => {
          commit('DELETE_EDITING_COURSE');
          commit('UPDATE_COURSE', response.data);
        });
      } else {
        return CourseService.create(formattedCourse).then((response) => {
          commit('DELETE_EDITING_COURSE');
          commit('ADD_COURSE', response.data);
        });
      }
    }
  },
  clearEditingCourse({ commit, state }) {
    if (state.editingCourse) {
      commit('DELETE_EDITING_COURSE');
    }
  },
  freezeCourse({ commit }, payload) {
    let formattedFrozenData = {};
    if (payload.frozenMonth != 'now') {
      formattedFrozenData['frozenDatetime'] = payload.frozenMonth;
    }
    return CourseService.frozen(payload.id, formattedFrozenData).then(() => {
      commit('FREEZE_COURSE');
    });
  },
};

export const getters = {
  getCourseById: (state) => (id) => {
    return state.courses.find((item) => item.id == id);
  },
  totalCourses: (state) => {
    return state.courses.length;
  },
  getExcelFormattedCourses: (state) => (fields) => {
    return map(state.courses, (course) => {
      let data = {
        法人名: basicSubFieldPresent(course, 'corporation', 'name'),
        ブランド名: basicSubFieldPresent(course, 'brand', 'name'),
        コース名: basicPresent(course.name),
        コースID: basicPresent(course.uid),
        確認テスト合格点数: basicPresent(course.testPassingScore).toString(),
      };

      return pick(data, fields);
    });
  },
  testPassingScoreOptions() {
    // _.range(0, 20, 5); => [0, 5, 10, 15]
    const allScores = range(5, 105, 5).map((score) => {
      return { text: `${score}点`, value: score };
    });

    return allScores;
  },
  existsRegistrationRequiredParams: (state) => {
    if (!state.editingCourse.name) return false;
    if (!state.editingCourse.nameReading) return false;

    return true;
  },
  existsUpdateRequiredParams: (state) => {
    if (!state.editingCourse.name) return false;
    if (!state.editingCourse.nameReading) return false;

    return true;
  },
};
